import "./WhoWeAre.scss";
import Btn from "../../../components/btn/Btn";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../utils/paths";
import { baseUrl } from "../../../utils/apiData";
import { Fragment } from "react";
import { Counter } from "../../about";

const WhoWeAre = ({ pageData }) => {
  const dataList = [
    {
      id: 0,
      icon: pageData?.sec_1_image,
      title: pageData?.sec_1_title,
      para: pageData?.sec_1_description,
    },
    {
      id: 1,
      icon: pageData?.sec_2_image,
      title: pageData?.sec_2_title,
      para: pageData?.sec_2_description,
    },
    {
      id: 2,
      icon: pageData?.sec_3_image,
      title: pageData?.sec_3_title,
      para: pageData?.sec_3_description,
    },
    {
      id: 3,
      icon: pageData?.sec_4_image,
      title: pageData?.sec_4_title,
      para: pageData?.sec_4_description,
    },
  ];

  const navigate = useNavigate();
  return (
    <Fragment>
      <section className="who_we_are p_t p_b">
        <div className="content_wrap">
          <div className="tri_grid">
            <div className="title_side">
              <motion.p
                initial={{ translateX: 32, opacity: 0 }}
                whileInView={{ translateX: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  ease: "easeInOut",
                }}
                viewport={{ once: true }}
                className="tag_title"
              >
                <span>_</span>
                {pageData?.who_we_are_title}
              </motion.p>
              <motion.h2
                initial={{ translateY: 32, opacity: 0 }}
                whileInView={{ translateY: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  ease: "easeInOut",
                }}
                viewport={{ once: true }}
              >
                {pageData?.who_we_are_heading}
              </motion.h2>
              <Btn
                title="About aaladamara"
                delay={0.15}
                onClick={() => navigate(`${paths.ABOUT}`)}
              />
            </div>
            <div className="inner_grid">
              {dataList?.map((data, k) => {
                return (
                  <motion.div
                    initial={{ translateY: 32, opacity: 0 }}
                    whileInView={{ translateY: 0, opacity: 1 }}
                    transition={{
                      duration: 0.6,
                      ease: "easeInOut",
                      delay: 0.15 * k,
                    }}
                    viewport={{ once: true }}
                    className="info_box"
                    key={data?.id}
                  >
                    <img src={`${baseUrl}/${data?.icon}`} alt="Info" />
                    <div className="info">
                      <h4>{data?.title}</h4>
                      <p className="t_18">{data?.para}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

       <Counter data={pageData} />
      <section className="who_we_are p_b">
        <div className="content_wrap">
          <div className="main_content">
            <motion.h2
              initial={{ translateY: 32, opacity: 0 }}
              whileInView={{ translateY: 0, opacity: 1 }}
              transition={{
                duration: 0.6,
                ease: "easeInOut",
              }}
              viewport={{ once: true }}
            >
              {pageData?.who_we_are_2_title}
            </motion.h2>
            <motion.div
              initial={{ translateY: 32, opacity: 0 }}
              whileInView={{ translateY: 0, opacity: 1 }}
              transition={{
                duration: 0.6,
                ease: "easeInOut",
                delkay: 0.15,
              }}
              viewport={{ once: true }}
              dangerouslySetInnerHTML={{
                __html: pageData?.who_we_are_description,
              }}
            ></motion.div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default WhoWeAre;
